import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Translate } from 'react-localize-redux';
import Alert, { ALERT_TYPES } from '../../components/atoms/Alert';
import { PAGE_MODES, ROLE_ORG_ADMIN, ROLE_RESTRICTED, ROLE_STANDARD, ROLES, translationPrefix } from '../utils';
import css from './RolePageStep.css';
import StepCard from './StepCard';

const RolePageStep = ({
    role = ROLE_STANDARD,
    mode = '',
    showRestrictedMode = false,
    onRoleSelection = () => {},
    onStepValidationStatusChanged = () => {},
    initialRole,
}) => {
    const isChangingToAdmin = role === ROLE_ORG_ADMIN && mode === PAGE_MODES.edit && initialRole !== ROLE_ORG_ADMIN;
    const roles = showRestrictedMode ? ROLES : ROLES.filter(r => r.id !== ROLE_RESTRICTED);

    useEffect(() => {
        onStepValidationStatusChanged({ isValid: true, title: '' });
    }, [onStepValidationStatusChanged, role]);

    return (
        <div className={css.container}>
            {isChangingToAdmin && (
                <Alert
                    type={ALERT_TYPES.WARNING}
                    text={`${translationPrefix}.CHANGING_TO_ADMIN_WARNING`}
                    className={css.alert}
                    alertIconClassName={css.alertIcon}
                />
            )}
            <StepCard
                className={css.stepCard}
                title={`${translationPrefix}.MANAGE_PERMISSIONS_PAGE.TITLE.ROLE_SELECTION`}
            >
                <div className={css.rolesList}>
                    {roles.map(r => (
                        <div
                            key={r.id}
                            className={classNames(css.roleItem, { [css.selected]: r.id === role })}
                            onClick={() => onRoleSelection(r.id)}
                        >
                            <input
                                id={r.id.toString()}
                                type="radio"
                                className={css.radioInput}
                                checked={r.id === role}
                                onChange={() => onRoleSelection(r.id)}
                            />
                            <div className={css.textContainer}>
                                <div className={css.roleType}>{r.label}</div>
                                <div className={css.roleDescription}>
                                    <Translate id={r.descriptionKey} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </StepCard>
        </div>
    );
};

RolePageStep.propTypes = {
    role: PropTypes.number,
    mode: PropTypes.string,
    showRestrictedMode: PropTypes.bool,
    onRoleSelection: PropTypes.func,
    onStepValidationStatusChanged: PropTypes.func,
    initialRole: PropTypes.number,
};

export default RolePageStep;
